import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Options, SliderComponent } from '@angular-slider/ngx-slider';
import { FormControl } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { CssServicesService } from '../../../services/css-services.service';
import { takeUntil } from 'rxjs/operators';
import { InputField } from '../../../model';
import { CssPropertyParserService } from '../../../editors/services/css-property-parser.service'

@Component({
  selector: 'kve-border-input',
  templateUrl: './border-input.component.html',
  styleUrls: ['./border-input.component.scss']
})
export class BorderInputComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() field:InputField;
  /**
   * Used to specify which border property to set.  Width/Radius
   */
  @Input() type:string;
  @Input() color:string = "#fff";
  /**
   * The service to be used for getting initial values 
   */
  @Input() service:string;
  /**
   * The object for which the border property will be set
   */
  @Input() target:string;
  @Input() borderString:string;
  @Input() borderRadiusString;
  @Output() borderChange = new EventEmitter<string>();
  @Output() borderRadiusChange = new EventEmitter<string>();

  borderStyle = "solid";
  sliderControl: FormControl = new FormControl(0);
  value:0;
  options: Options = {
    floor: 0,
    step:1,
    ceil: 5
  };
  valueAll = 0;
  valueTop;
  valueRight;
  valueBottom;
  valueLeft;
  colors:string[] = [];
  colorSubscription:Subscription;
  private destroy$ = new Subject<void>();

  selectedUom;
  uoms = [
    {name:"px",value:"px"},
    {name:"rem",value:"rem"},
    {name:"em",value:"em"},
    {name:"%",value:"%"},
  ]

  @ViewChild('narrowSelect',{read: ElementRef}) narrowSelect:ElementRef;
  @ViewChild('twitterColor', {read: ElementRef}) twitterColor: ElementRef;
  @ViewChild('valueSlider') valueSlider: SliderComponent;

  constructor(
    private cssServices:CssServicesService,
    private cssPropertyParserService:CssPropertyParserService
  ) { }

  ngOnInit(): void {
    this.selectedUom = this.uoms[0];
    this.colorSubscription = this.cssServices.getBorderColors()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
        for (let [k,v] of Object.entries(data)) {
          this.colors.push(v);
        }
    })
  }
  /* initDefaultValues(){
    if(this.service == "cellEditorStoreService") {
      if(this.target == "content" || this.target == "contentElement" || this.target == "parent"){
        if(this.target == "content" || this.target == "contentElement"){
          this.borderString = this.contentElement.border?this.contentElement.border:"";
        }else if(this.target == "parent"){
          this.borderString = this.contentElement.parentBorder?this.contentElement.parentBorder:"";
        }
      }
    }else if(this.service == "sectionEditorStoreService"){

    }
  } */
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["type"]){
      if(this.field != undefined){
        let type = this.type;
        this.field = {...this.field,type}
      }
    }
    if(changes["borderString"] || changes["borderRadiusString"]){
      if(this.borderString != undefined && this.borderString != ""){
        const result = this.cssPropertyParserService.parseBorder(this.borderString)
        console.log(result)
        // Extract numerical values from border result
        this.color = result.color;
        this.valueAll = this.cssPropertyParserService.extractNumber(result.valueAll);
        if(this.valueAll && this.valueAll > 0){
          this.value = <any><number>this.valueAll;
          this.sliderControl.setValue(this.valueAll)
          console.log(this.value);
        }
        this.valueTop = this.cssPropertyParserService.extractNumber(result.valueTop);
        this.valueRight = this.cssPropertyParserService.extractNumber(result.valueRight);
        this.valueBottom = this.cssPropertyParserService.extractNumber(result.valueBottom);
        this.valueLeft = this.cssPropertyParserService.extractNumber(result.valueLeft);
        this.selectedUom = this.uoms.map(uom => uom.name === this.cssPropertyParserService.getUnitFromResult(result) ? uom:this.uoms[0])
      }
      if(this.borderRadiusString != undefined && this.borderRadiusString != ""){
        const result = this.cssPropertyParserService.parseBorderRadius(this.borderRadiusString)
        console.log(result)
        // Extract numerical values from border-radius result
        this.valueAll = this.cssPropertyParserService.extractNumber(result.valueAll);
        this.valueTop = this.cssPropertyParserService.extractNumber(result.topLeft); // or topRight, depending on your logic
        this.valueRight = this.cssPropertyParserService.extractNumber(result.topRight); // or bottomRight
        this.valueBottom = this.cssPropertyParserService.extractNumber(result.bottomRight); // or bottomLeft
        this.valueLeft = this.cssPropertyParserService.extractNumber(result.bottomLeft); // or topLeft
        this.selectedUom = this.uoms.map(uom => uom.name === this.cssPropertyParserService.getUnitFromResult(result) ? uom:this.uoms[0])
      }
    }
    /* if(changes["color"]){
      console.log(this.color)
      if(this.selectedUom == undefined){
        this.selectedUom = this.uoms[0];
      }
      this.emitChanges() 
      
    } */
  }
  ngAfterViewInit(): void {
    let _narrowSelect = <HTMLElement> this.narrowSelect.nativeElement;
    let selectButs = _narrowSelect.querySelectorAll('.select-button');
    if(selectButs != undefined){
      for(let i=0;i<selectButs.length;i++){
        let selectBut = <HTMLElement>selectButs[i];
        selectBut.style.width = "50%";  
      }
      
    }
  }


  // UOM change handler
  changeUom(selectedUom: any): void {
    this.selectedUom = selectedUom;
    this.emitChanges();
  }
// Slider handlers
  sliderUserChange(e){
    console.log("sliderUserChange",e)
  }

  sliderUserChangeStart(e){
    console.log("sliderUserChangeStart",e)
  }
  
  sliderUserChangeEnd(e){
    this.valueAll = e.value;
    console.log("sliderUserChangeEnd",e.value);
    this.onValueAllChange();
  }

  onValueAllChange(): void {
    this.valueTop = this.valueRight = this.valueBottom = this.valueLeft = this.valueAll;
    console.log({top:this.valueTop,bottom:this.valueBottom})
    this.sliderControl.setValue(this.valueAll);
    this.emitChanges();
  }
  onIndividualValueChange(): void {
    // Update valueAll if all individual values are the same
    if (this.allValuesEqual()) {
      this.valueAll = this.valueTop;
      this.sliderControl.setValue(this.valueAll);
    }
    this.emitChanges();
  }
  private allValuesEqual(): boolean {
    return this.valueTop === this.valueRight && 
           this.valueRight === this.valueBottom && 
           this.valueBottom === this.valueLeft;
  }


  

  // Color change handlers
  handleChangeComplete(colorEvent: any): void {
    this.color = colorEvent.color?.hex || colorEvent;
    this.emitChanges();
  }

  changeComplete(colorEvent: any): void {
    this.handleChangeComplete(colorEvent);
  }

  // Border style change
  onBorderStyleChange(style: string): void {
    this.borderStyle = style;
    this.emitChanges();
  }

  // CSS generation methods
  private generateBorderString(): string {
    if (this.type === 'width') {
      const width = this.getBorderWidthString();
      return `${width} ${this.borderStyle} ${this.color}`;
    }
    return '';
  }

  private generateBorderRadiusString(): string {
    if (this.type === 'radius') {
      if (this.allValuesEqual()) {
        return `${this.valueAll}${this.selectedUom.value}`;
      }
      return `${this.valueTop}${this.selectedUom.value} ${this.valueRight}${this.selectedUom.value} ${this.valueBottom}${this.selectedUom.value} ${this.valueLeft}${this.selectedUom.value}`;
    }
    return '';
  }

  private getBorderWidthString(): string {
    if (this.allValuesEqual()) {
      return `${this.valueAll}${this.selectedUom.value}`;
    }
    return `${this.valueTop}${this.selectedUom.value} ${this.valueRight}${this.selectedUom.value} ${this.valueBottom}${this.selectedUom.value} ${this.valueLeft}${this.selectedUom.value}`;
  }

  // Emit changes to parent component
  private emitChanges(): void {
    if (this.type === 'width') {
      const borderString = this.generateBorderString();
      console.log(borderString);
      this.borderChange.emit(borderString);
    } else if (this.type === 'radius') {
      const borderRadiusString = this.generateBorderRadiusString();
      this.borderRadiusChange.emit(borderRadiusString);
    }
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  

}
